import * as API from '@/api/system/model';
import { makeTree } from '@/libs/utils';

export default {
  data() {
    return {
      // 所有模型
      modelList: [],
      modelListTree: [],
      modelAliasObject: {},
    };
  },

  methods: {
    // 获取当前所有模型列表
    getAllModelList(callback) {
      const ModelListAPI = this.form.stationId
        ? API.DeviceModelListAllByStation
        : API.DeviceModelListAll;

      const params = {};
      if (this.form.stationId) {
        params.stationId = this.form.stationId;
      }

      return ModelListAPI(params).then(res => {
        if (res.code === 0) {
          this.modelList = res.data || [];
          this.modelListTree = makeTree({
            data: this.modelList,
            idName: 'devModelId',
            parentIdName: 'parentId',
          }).array;

          // 获取模型别名
          const devModelIdList = this.modelList.map(item => item.devModelId);
          return this.getModelAlias(devModelIdList, callback);
        }
      });
    },

    // 获取设备模型别名
    getModelAlias(devModelIdList, callback) {
      if (!(devModelIdList && devModelIdList.length)) {
        return Promise.resolve();
      }

      return API.DeviceModelAliasGet({ devModelIds: devModelIdList.join(',') }).then(res => {
        if (res.code === 0) {
          const data = res.data || [];
          data.forEach(item => {
            if (item.aliasName) {
              this.modelAliasObject[item.devModelId] = item.aliasName;
            }
          });

          callback && callback();
        }
      });
    },
  },
};
